import ResumeExampleEditing from './resume-example-editing';
import { Plugin } from '@ckeditor/ckeditor5-core';
import './styles.css';
class ResumeExampleUI extends Plugin {
    init() { }
}
export default class ResumeExample extends Plugin {
    static get requires() {
        return [ResumeExampleEditing, ResumeExampleUI];
    }
}
